import React, { useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { KeyRound, Loader2, MailCheck } from "lucide-react";

/** Phase 90 — « Espace client » : le visiteur saisit son email, un lien magique lui est envoyé s'il est connu de l'établissement. */
export function ClientAccessDialog({ open, onOpenChange, postUrl, entrepriseName }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { const { data } = await api.post(postUrl, { email: email.trim() }); setSent(data.message || "Si cette adresse est connue, un lien vient de vous être envoyé."); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || "Envoi impossible"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) { setSent(""); setError(""); } }}>
      <DialogContent className="max-w-md" data-testid="client-access-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black flex items-center gap-2"><KeyRound className="h-5 w-5 text-[#002FA7]" />Espace client</DialogTitle>
          <DialogDescription className="text-xs">Réservations, demandes, documents, devis et factures{entrepriseName ? ` chez ${entrepriseName}` : ""} — sans mot de passe : nous vous envoyons un lien d'accès personnel par email.</DialogDescription>
        </DialogHeader>
        {sent ? (
          <div className="border border-[#A7F3D0] bg-[#ECFDF5] p-4 text-sm flex items-start gap-2" data-testid="client-access-sent"><MailCheck className="h-5 w-5 text-[#059669] shrink-0" /><span>{sent}</span></div>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="client-access-form">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.fr" className="h-11" autoComplete="email" data-testid="client-access-email" />
            {error && <div className="text-xs text-[#E60000]" role="alert" data-testid="client-access-error">{error}</div>}
            <Button type="submit" disabled={busy || !email.trim()} className="h-11 w-full bg-[#0A0A0A] hover:bg-[#333] text-white font-bold" data-testid="client-access-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <KeyRound className="h-4 w-4 mr-2" />}Recevoir mon lien d'accès</Button>
            <div className="text-[11px] text-[#868E96]">Vous n'êtes pas encore client ? Faites une demande ou une réservation : votre espace est créé automatiquement.</div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
